<template>
  <div>
    <v-row row wrap>
      <v-col>
        <v-btn
          color="primary"
          outlined
          small
          @click="handleClickCloseLibrary"
          class="pull-left mr-5"
        >
          Back
        </v-btn>
        <span class="details-heading application-heading">
          Search Library
        </span>
        <v-icon
          size="18"
          title="Close panel"
          class="mr-2 pull-right"
          @click="handleClickClose"
          >fas fa-times</v-icon
        >
      </v-col>
    </v-row>
    <v-row row wrap>
      <v-col>
        <Loader v-if="loading" text=""></Loader>
        <div v-if="!loading && !searchLibrary.length">No searches found.</div>
        <div v-if="!loading && searchLibrary.length">
          <v-data-iterator
            hide-default-footer
            :items="searchLibrary"
            :items-per-page.sync="itemsPerPage"
            :page.sync="page"
          >
            <template v-slot:default="{ items }">
              <div class="search-library-list">
                <v-card
                  flat
                  class="my-2 pa-2"
                  v-for="item in items"
                  :key="item.id"
                >
                  <div class="search-library-item">
                    <div>
                      <div v-html="item.name"></div>
                      <div class="caption" v-html="item.description"></div>
                    </div>
                    <div>{{ dateFormatted(item.createdAt) }}</div>
                    <div>
                      <v-btn
                        color="primary"
                        outlined
                        small
                        @click="viewSearchResults(item)"
                        class="pull-right ml-2"
                      >
                        View Results
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </div>
            </template>

            <!-- Custom Footer -->
            <template v-slot:footer>
              <v-row class="mt-2 mx-2" align="center" justify="center">
                <span class="grey--text">Items per page</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      dark
                      text
                      color="primary"
                      class="ml-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ itemsPerPage }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(number, index) in itemsPerPageArray"
                      :key="index"
                      @click="updateItemsPerPage(number)"
                    >
                      <v-list-item-title>{{ number }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-spacer></v-spacer>

                <span class="mr-4 grey--text"> Page {{ page }} </span>
                <v-btn
                  :disabled="page <= 1 || loading"
                  fab
                  x-small
                  color="primary"
                  class="mr-1"
                  @click="formerPage"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                  :disabled="!showNext || loading"
                  fab
                  x-small
                  color="primary"
                  class="ml-1"
                  @click="nextPage"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-row>
            </template>
          </v-data-iterator>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getSearchLibrary } from "@/services/search/searchLibrary.service";
import { getFormatted } from "@/common/date.utilities";

const EMITTED_ACTIONS = {
  CLOSE_LIBRARY: "close-library",
  CLICK_CLOSE: "click-close",
  VIEW_SEARCH_RESULTS: "view-search-results",
};

export default {
  name: "SearchLibrary",
  props: {},
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  data() {
    return {
      loading: false,
      itemsPerPageArray: [10, 20, 40, 80],
      page: 1,
      itemsPerPage: 10,
      searchLibrary: [],
      nextToken: null,
    };
  },
  async mounted() {
    this.getSearches();
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.searchLibrary.length / this.itemsPerPage);
    },
    showNext() {
      return this.page + 1 <= this.numberOfPages || this.nextToken;
    },
  },
  methods: {
    handleClickCloseLibrary() {
      this.$emit(EMITTED_ACTIONS.CLOSE_LIBRARY, true);
    },
    handleClickClose() {
      this.$emit(EMITTED_ACTIONS.CLICK_CLOSE, true);
    },
    viewSearchResults(search) {
      this.$emit(EMITTED_ACTIONS.VIEW_SEARCH_RESULTS, search);
    },
    reloadLibrary() {
      this.searchLibrary = [];
      this.nextToken = null;
      this.page = 1;
      this.getSearches();
    },
    async getSearches(token) {
      this.loading = true;
      const searchLibrary = await getSearchLibrary(this.itemsPerPage, token);
      this.searchLibrary = this.searchLibrary.concat(searchLibrary.searches);
      this.nextToken = searchLibrary.nextToken;
      this.loading = false;
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) {
        this.page += 1;
      } else {
        this.getSearches(this.nextToken);
        this.page += 1;
      }
    },
    formerPage() {
      if (this.page - 1 >= 1) {
        this.page -= 1;
      }
    },
    updateItemsPerPage(number) {
      if (number > this.itemsPerPage) {
        this.itemsPerPage = number;
        this.reloadLibrary();
      } else {
        this.itemsPerPage = number;
      }
    },
    dateFormatted(date) {
      return getFormatted(date);
    },
  },
};
</script>
<style scoped>
.details-heading {
  font-size: 20px;
}
.search-library-list {
  max-height: calc(100vh - 125px);
  overflow-y: auto;
}
.search-library-item {
  display: grid;
  grid-template-columns: 1fr 200px 100px;
  grid-gap: 1rem;
}
</style>
